import axios from 'axios'

export const getConfiguration = ({ commit }, configurl) => {
  commit('setLoading', true);
  axios.get(configurl)
    .then(response => {
      commit('getConfig', response.data)
    })
    // fail
    .catch(e => {
      commit('getConfig', e.response)
    })
    .finally(() => {
      commit('setLoading', false);
    });
}